// John Eldhose 20180713
import { RestfulPost } from './Restful';

export async function addAddress(data) {
  const addr = await RestfulPost('addAddress', {data: data}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return addr;
}



// WEBPACK FOOTER //
// ./src/Api/addAddress.js